<template>
  <div>
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
          xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <b-container class="mt--8 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="8" md="10">         
      
        <div class="top-0 left-0 p-3">
          <base-button type="secondary" @click="$router.push('/login');">
            <i class="fa fa-arrow-left"></i> {{ $t('volver') }}
          </base-button>
        </div>

          <b-card no-body class="bg-secondary mb-0">
            <b-card-body class="px-lg-5 py-lg-5">
              <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
                <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">

                  <h4 class="mt-1">{{ $t('informacion_empresa') }}</h4>
                  <b-row>
                    <b-col md="6">
                      <p class="p-login">{{ $t('nombre_empresa') }} <span style="color:red">*</span></p>
                      <b-form-input class="mb-3" required v-model="form.nombreEmpresa"
                        :placeholder="$t('nombre_empresa_placeholder')"></b-form-input>
                    </b-col>
                    <b-col md="6">
                      <p class="p-login">{{ $t('rut_empresa') }} <span style="color:red">*</span></p>
                      <b-form-input class="mb-3" required v-model="form.rutEmpresa"
                        :placeholder="$t('rut_empresa_placeholder')"></b-form-input>
                    </b-col>
                    <b-col md="6">
                      <p class="p-login">{{ $t('direccion') }}</p>
                      <b-form-input class="mb-3" v-model="form.direccion" :placeholder="$t('direccion')"></b-form-input>
                    </b-col>
                    <b-col md="6">
                      <p class="p-login">{{ $t('pais') }} <span style="color:red">*</span></p>
                      <el-select class="custom-input" v-model="form.pais" @change="onChangePais" filterable clearable
                        :placeholder="$t('seleccione')">
                        <el-option v-for="item in opcionesPaises" :key="item.value" :label="item.text"
                          :value="item.value" />
                      </el-select>
                    </b-col>
                    <b-col md="6">
                      <p class="p-login">{{ $t('region') }} <span style="color:red">*</span></p>
                      <el-select class="custom-input" :disabled="!form.pais" @change="onChangeRegion"
                        v-model="form.region" filterable clearable :placeholder="$t('seleccione')">
                        <el-option v-for="item in opcionesRegiones" :key="item.value" :label="item.text"
                          :value="item.value" />
                      </el-select>
                    </b-col>
                    <b-col md="6">
                      <p class="p-login">{{ $t('comuna') }} <span style="color:red">*</span></p>
                      <el-select class="custom-input" :disabled="!form.region" v-model="form.comuna" filterable
                        clearable :placeholder="$t('seleccione')">
                        <el-option v-for="item in opcionesComunas" :key="item.value" :label="item.text"
                          :value="item.value" />
                      </el-select>
                    </b-col>
                    <b-col md="6">
                      <p class="p-login">{{ $t('industria') }}</p>
                      <b-form-input class="mb-3" v-model="form.industria" :placeholder="$t('industria')"></b-form-input>
                    </b-col>
                    <b-col md="6">
                      <p class="p-login">{{ $t('web') }}</p>
                      <b-form-input class="mb-3" v-model="form.web" :placeholder="$t('sitio_web')"></b-form-input>
                    </b-col>
                  </b-row>

                  <h4 class="mt-1">{{ $t('informacion_contacto') }}</h4>
                  <b-row>
                    <b-col md="6">
                      <p class="p-login">{{ $t('nombre_contacto') }} <span style="color:red">*</span></p>
                      <b-form-input class="mb-3" required v-model="form.nombreContacto"
                        :placeholder="$t('nombre_contacto_placeholder')"></b-form-input>
                    </b-col>
                    <b-col md="6">
                      <p class="p-login">{{ $t('apellido_contacto') }} <span style="color:red">*</span></p>
                      <b-form-input class="mb-3" required v-model="form.apellidoContacto"
                        :placeholder="$t('apellido_contacto_placeholder')"></b-form-input>
                    </b-col>
                    <b-col md="6">
                      <p class="p-login">{{ $t('mail_contacto') }} <span style="color:red">*</span></p>
                      <b-form-input class="mb-3" required v-model="form.correo"
                        :placeholder="$t('correo_electronico')"></b-form-input>
                    </b-col>
                    <b-col md="6">
                      <p class="p-login">{{ $t('telefono_contacto') }}</p>
                      <b-form-input class="mb-3" v-model="form.telefono" :placeholder="$t('fono')"></b-form-input>
                    </b-col>
                    <b-col md="6">
                      <p class="p-login">{{ $t('contrasena') }} <span style="color:red">*</span></p>
                      <div class="input-group">
                        <b-form-input @blur="validatePassword" @change="validatePassword" class="border rounded-left"
                          required :placeholder="$t('contrasena')" :type="showPassword ? 'text' : 'password'"
                          v-model="form.password"></b-form-input>
                        <div class="input-group-append">
                          <button class="btn btn-outline-secondary border rounded-right" type="button"
                            @click="togglePassword">
                            <i :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                          </button>
                        </div>
                      </div>
                      <span v-if="passwordError" style="color: red; font-size: 12px;">{{ $t('contrasena_minimo') }}</span>
                    </b-col>
                    <b-col md="6">
                      <p class="p-login">{{ $t('repetir_contrasena') }} <span style="color:red">*</span></p>
                      <div class="input-group">
                        <b-form-input @blur="validatePassword" @change="validatePassword" class="border rounded-left"
                          required :placeholder="$t('contrasena')" :type="showPassword ? 'text' : 'password'"
                          v-model="password"></b-form-input>

                      </div>
                      <span v-if="passwordError2" style="color: red; font-size: 12px;">{{ $t('contrasena_minimo') }}</span>
                      <span v-else-if="!passwordIgual" style="color: red; font-size: 12px;">{{ $t('contrasenas_no_iguales') }}</span>
                    </b-col>
                  </b-row>

                  <h4 class="mt-4">{{ $t('intereses') }}</h4>
                  <b-row>
                    <b-col class="mb-4" md="4">
                      <p class="p-login">{{ $t('tipos_equipos') }}</p>
                      <el-select class="custom-input" v-model="form.tipoEquipos" multiple filterable clearable
                        :placeholder="$t('seleccione')">
                        <el-option v-for="item in opcionesEquipos" :key="item.value" :label="item.text"
                          :value="item.value" />
                      </el-select>
                    </b-col>
                    <b-col md="4">
                      <p class="p-login">{{ $t('marca') }}</p>
                      <el-select class="custom-input" v-model="form.marcas" multiple filterable clearable
                        :placeholder="$t('seleccione')">
                        <el-option v-for="item in opcionesMarcas" :key="item.value" :label="item.text"
                          :value="item.value" />
                      </el-select>
                    </b-col>
                    <b-col md="4">
                      <p class="p-login">{{ $t('componentes') }}</p>
                      <el-select class="custom-input" v-model="form.componentes" multiple filterable clearable
                        :placeholder="$t('seleccione')">
                        <el-option v-for="item in opcionesComponentes" :key="item.value" :label="item.text"
                          :value="item.value" />
                      </el-select>
                    </b-col>

                    <b-col class="mb-4" md="4">
                      <p class="p-login">{{ $t('estado_nuevo_usado') }}</p>
                      <el-select class="custom-input" v-model="form.estado" multiple filterable clearable
                        :placeholder="$t('seleccione')">
                        <el-option v-for="item in opcionesEstado" :key="item.value" :label="item.text"
                          :value="item.value" />
                      </el-select>
                    </b-col>
                    <b-col class="mb-4" md="4">
                      <p class="p-login">{{ $t('procesos') }}</p>
                      <el-select class="custom-input" v-model="form.procesos" multiple filterable clearable
                        :placeholder="$t('seleccione')">
                        <el-option v-for="item in opcionesProcesos" :key="item.value" :label="item.text"
                          :value="item.value" />
                      </el-select>
                    </b-col>
                  </b-row>

                  <div class="text-center">
                    <base-button type="primary" native-type="submit" class="my-4">{{ $t('registrar') }}</base-button>
                    <base-button type="secondary" class="my-4 ml-3" @click="resetForm">{{ $t('limpiar') }}</base-button>
                  </div>
                </b-form>
              </validation-observer>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { Select, Option } from 'element-ui'
import interesService from '@/api/interesService';
import zonaService from '@/api/zonaService';
import authService from '@/api/authService';
export default {
  name: 'Register',
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      form: {
        nombreEmpresa: '',
        direccion: '',
        telefono: '',
        industria: '',
        rutEmpresa: '',
        correo: '',
        web: '',
        nombreContacto: '',
        apellidoContacto: '',
        password: '',
        tipoEquipos: [],
        marcas: [],
        componentes: [],
        estado: [],
        procesos: [],
      },
      password: '',
      intereses: [],
      opcionesEquipos: [],
      opcionesMarcas: [],
      opcionesPaises: [],
      opcionesRegiones: [],
      opcionesComunas: [],      
      opcionesComponentes: [],
      opcionesEstado: [],
      opcionesProcesos: [],
      showPassword: false,
      passwordError: false,
      passwordError2: false,
      passwordIgual: true
    };
  },
  async beforeMount() {
    window.stop();
    localStorage.clear();
    const interesesPromise = interesService.getInteresOptions();
    const opcionesPaisesPromise = zonaService.getPaisesOptions();

    this.opcionesPaises = await opcionesPaisesPromise;
    const intereses = await interesesPromise;
    this.intereses = intereses;

    this.opcionesEstado = this.intereses.find(t => t.tipo == 'estados').options;
    this.opcionesMarcas = this.intereses.find(t => t.tipo == 'marcas').options;
    this.opcionesEquipos = this.intereses.find(t => t.tipo == 'tipoequipos').options;
    this.opcionesComponentes = this.intereses.find(t => t.tipo == 'componentes').options;
    this.opcionesProcesos = this.intereses.find(t => t.tipo == 'procesos').options;
  },
  methods: {
    async onChangePais() {

      this.opcionesRegiones = await zonaService.getRegionesOptions(this.form.pais);

    },
    async onChangeRegion() {

      this.opcionesComunas = await zonaService.getComunasOptions(this.form.region);

    },
    validatePassword() {
      if (this.form.password.length > 0) this.passwordError = this.form.password.length < 5;
      if (this.password.length > 0) this.passwordError2 = this.password.length < 5;
      if (this.form.password == this.password)
        this.passwordIgual = true;
      else
        this.passwordIgual = false;
    },
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    async onSubmit() {

      if (this.passwordError == true || !this.passwordIgual) {
        this.$toast.error(this.$t('contrasena_no_valida'), {
          position: 'top-center',
          timeout: 2000,
          closeOnClick: true,
          pauseOnHover: true
        });
        return;
      }
      if (!this.form.pais || !this.form.region || !this.form.comuna) {
        this.$toast.error(this.$t('verificar_datos_pais_region'), {
          position: 'top-center',
          timeout: 2000,
          closeOnClick: true,
          pauseOnHover: true
        });
        return;
      }

      Swal.fire({
        title: this.$t('seguro_registrarse'),
        text: this.$t('verificar_datos_pregunta'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('registrar'),
        cancelButtonText: this.$t('cancelar')
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            Swal.fire({
              html: `<div style="display: flex; align-items: center; justify-content: center;">
                      <img src="/img/others/loading.gif" alt="Loading" style="width: 50px; height: 50px; margin-right: 15px;">
                        <div>
                            <h3 style="color: #006393;">${this.$t('registrando')}</h3>
                        </div>
                    </div>`,
              showConfirmButton: false,
              allowOutsideClick: false
            });
            const response = await authService.register(this.form);
            if (!response) {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: this.$t('error_crear_ingreso')
              });
              return;
            }

            Swal.fire({
              title: this.$t('registrado_correctamente'),
              icon: "success",
              showConfirmButton: false,
              timer: 2000,
              background: '#f8f9fa',
              customClass: {
                title: 'swal-title',
                icon: 'swal-icon',
              },
            });
            this.$router.push(`/login`);

          } catch (error) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: error.message || this.$t('error_desconocido')
            });
          }
        }
        else if (result.isDenied) {
          Swal.close();
        }
      });
    },
    resetForm() {
      this.form = {
        nombreEmpresa: '',
        direccion: '',
        nombreContacto: '',
        apellidoContacto: '',
        telefono: '',
        industria: '',
        password: '',
        rutEmpresa: '',
        correo: '',
        web: '',
        pais: null,
        region: null,
        comuna: null,
        tipoEquipos: [],
        marcas: [],
        componentes: [],
        estado: [],
        procesos: []
      };
      this.password = '';
      this.passwordError = false;
      this.passwordIgual = true;
    }
  }
};
</script>

<style scoped>
.p-login {
  margin-bottom: 0;
}

.el-select {
  display: block
}
</style>
